import { produce } from "immer";
import {
    BONUSES_SET_ACTIVE_SUCCESS,
    BONUSES_SET_AVAILABLE,
    CLEAR_BONUSES,
    GET_NEW_LIFE_ACCOUNTS_FAILURE,
    GET_NEW_LIFE_ACCOUNTS_START,
    GET_NEW_LIFE_ACCOUNTS_SUCCESS,
    SET_NEW_LIFE_RESPAWN_BANNER_OPENED,
    SET_NEW_LIFE_RESPAWN_FAILURE,
    SET_NEW_LIFE_RESPAWN_START,
    SET_NEW_LIFE_RESPAWN_SUCCESS,
    SET_WELCOME_APPLY_BONUS,
    SET_WELCOME_BANNER_OPENED
} from "./bonusesConstants";

const initialState = {
    bonusesActiveList: [],
    bonusesAvailableList: [],

    welcomeApplyBonus: false,
    welcomeBannerOpened: true,

    newLifeAccounts: [],
    newLifeAccountsError: null,
    newLifeAccountsIsLoading: false,

    newLifeRespawnError: null,
    newLifeRespawnInProgress: false,
    newLifeRespawnSuccess: false,
    newLifeRespawnBannerOpened: true,
};

const bonusesReducer = (state = initialState, action) =>
    produce(state, (draft) => {
        switch (action.type) {

            case CLEAR_BONUSES:
                return { ...initialState };

            case BONUSES_SET_ACTIVE_SUCCESS:
                draft.bonusesActiveList = action.payload || [];
                break;

            case BONUSES_SET_AVAILABLE:
                draft.bonusesAvailableList = action.payload || [];
                break;

            case SET_WELCOME_APPLY_BONUS:
                draft.welcomeApplyBonus = action.payload;
                break;

            case SET_WELCOME_BANNER_OPENED:
                draft.welcomeBannerOpened = action.payload;
                break;

            case GET_NEW_LIFE_ACCOUNTS_START:
                draft.newLifeAccountsError = null;
                draft.newLifeAccountsIsLoading = true;
                break;
            case GET_NEW_LIFE_ACCOUNTS_SUCCESS:
                draft.newLifeAccounts = action.payload || [];
                draft.newLifeAccountsIsLoading = false;
                break;
            case GET_NEW_LIFE_ACCOUNTS_FAILURE:
                draft.newLifeAccountsError = null;
                draft.newLifeAccountsIsLoading = false;
                break;

            case SET_NEW_LIFE_RESPAWN_START:
                draft.newLifeRespawnError = null;
                draft.newLifeRespawnInProgress = true;
                draft.newLifeRespawnSuccess = false;
                break;
            case SET_NEW_LIFE_RESPAWN_SUCCESS:
                draft.newLifeRespawnInProgress = false;
                draft.newLifeRespawnSuccess = true;
                break;
            case SET_NEW_LIFE_RESPAWN_FAILURE:
                draft.newLifeRespawnError = action.payload;
                draft.newLifeRespawnInProgress = false;
                break;
            case SET_NEW_LIFE_RESPAWN_BANNER_OPENED:
                draft.newLifeRespawnBannerOpened = action.payload;
                break;

            default:
                return state;
        }
    });

export default bonusesReducer;
